import { getSupabaseVideoUrl } from '../utils/videoUtils';

export const channelsData = [
  {
    id: 'reality-tv',
    name: 'Reality TV',
    shortcut: '1',
    description: 'De beste realityshows',
    secondaryHero: {
      title: 'Monique',
      subtitle: 'Exclusieve reality',
      description: 'Volg het leven van Monique Smit in deze openhartige realityserie. Een unieke kijk achter de schermen.',
      backgroundImage: '/content/reality/monique.webp',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Monique.mp4'),
      cta: 'Kijk nu!'
    },
    hero: {
      title: 'Yves Berendse',
      subtitle: 'Live in concert',
      description: 'Beleef de magie van Yves Berendse tijdens zijn eerste concert in de Ziggo Dome.',
      backgroundImage: '/content/reality/yves.jpeg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Yves.mp4'),
      cta: 'Kijk nu!'
    },
    sections: [
      {
        title: 'Populaire reality',
        shows: [
          {
            id: 101,
            title: 'Yves',
            image: '/content/reality/yves.jpeg',
            duration: '30 min',
            rating: '8.1'
          },
          {
            id: 102,
            title: 'Het huis van Henk',
            image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=400&q=80',
            duration: '25 min',
            rating: '8.5'
          },
          {
            id: 103,
            title: 'Zing Je Rot',
            image: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&q=80',
            duration: '25 min',
            rating: '8.2'
          },
          {
            id: 104,
            title: 'Verleiding op Vlieland',
            image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&q=80',
            duration: '30 min',
            rating: '7.8'
          },
          {
            id: 105,
            title: 'Overleven in de Polder',
            image: 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=400&q=80',
            duration: '25 min',
            rating: '8.7'
          },
          {
            id: 106,
            title: 'Liefde op het Eerste Gezicht',
            image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80',
            duration: '30 min',
            rating: '7.5'
          },
          {
            id: 107,
            title: 'Het Komplot',
            image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&q=80',
            duration: '25 min',
            rating: '8.9'
          }
        ]
      },
      {
        title: 'Nieuwe reality',
        shows: [
          {
            id: 108,
            title: 'Voetjes van de vloer',
            image: 'https://images.unsplash.com/photo-1535525153412-5a42439a210d?w=400&q=80',
            duration: '30 min',
            rating: '7.9'
          },
          {
            id: 109,
            title: 'Wie zit er in het pak?',
            image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&q=80',
            duration: '25 min',
            rating: '8.3'
          },
          {
            id: 110,
            title: 'Trouwen met een vreemde',
            image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=400&q=80',
            duration: '30 min',
            rating: '8.0'
          },
          {
            id: 111,
            title: 'Boer zoekt man',
            image: 'https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=400&q=80',
            duration: '25 min',
            rating: '8.6'
          },
          {
            id: 112,
            title: 'De Saboteur',
            image: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=400&q=80',
            duration: '30 min',
            rating: '9.2'
          }
        ]
      },
      {
        title: 'Meer reality',
        shows: [
          {
            id: 113,
            title: 'Alles voor de liefde',
            image: 'https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?w=400&q=80',
            duration: '25 min',
            rating: '7.7'
          },
          {
            id: 114,
            title: 'Hollands talent',
            image: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400&q=80',
            duration: '30 min',
            rating: '8.1'
          },
          {
            id: 115,
            title: 'Gooische realiteit',
            image: 'https://images.unsplash.com/photo-1496337589254-7e19d01cec44?w=400&q=80',
            duration: '30 min',
            rating: '7.4'
          },
          {
            id: 116,
            title: 'De slimste thuis',
            image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=400&q=80',
            duration: '25 min',
            rating: '8.8'
          }
        ]
      },
      {
        title: 'Top reality',
        shows: [
          {
            id: 117,
            title: 'Zootopia',
            image: 'https://images.unsplash.com/photo-1464047736614-af63643285bf?w=400&q=80',
            duration: '30 min',
            rating: '9.0'
          },
          {
            id: 118,
            title: 'Het verraad',
            image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&q=80',
            duration: '25 min',
            rating: '8.9'
          },
          {
            id: 119,
            title: 'Expeditie Robert',
            image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&q=80',
            duration: '30 min',
            rating: '8.7'
          },
          {
            id: 120,
            title: 'Sterren in je huis',
            image: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=400&q=80',
            duration: '30 min',
            rating: '8.6'
          },
          {
            id: 121,
            title: 'De oude stem',
            image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&q=80',
            duration: '25 min',
            rating: '8.5'
          }
        ]
      }
    ]
  },
  {
    id: 'sponsored-reality',
    name: 'Sponsored Reality',
    shortcut: '2',
    description: 'Realityshows met exclusieve partners',
    hero: {
      title: 'Fitchannel',
      subtitle: 'Powered by Fitchannel',
      description: 'Op maat gemaakte workouts, gebalanceerde maaltijden en mindfulness-sessies..',
      backgroundImage: '/content/sponsored/fitchannel.jpg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Fitchannel.mp4'),
      cta: 'Kijk nu!',
      sponsor: 'Fitchannel'
    },
    secondaryHero: {
      title: 'Waternet',
      subtitle: 'Powered by Waternet',
      description: 'Ontdek hoe Waternet werkt aan een duurzame toekomst voor Amsterdam en omstreken.',
      backgroundImage: '/content/sponsored/waternet.jpeg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Waternet.mp4'),
      cta: 'Kijk nu!',
      sponsor: 'Waternet'
    },
    sections: [
      {
        title: 'Brand Partnerships',
        shows: [
          {
            id: 201,
            title: 'Waternet',
            image: '/content/sponsored/waternet.jpeg',
            duration: '30 min',
            rating: '8.0',
            sponsor: 'Waternet'
          },
          {
            id: 202,
            title: 'Het beste van NL',
            image: 'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400&q=80',
            duration: '25 min',
            rating: '8.4',
            sponsor: 'Heineken'
          },
          {
            id: 203,
            title: 'Meesterkok',
            image: 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=400&q=80',
            duration: '30 min',
            rating: '8.1',
            sponsor: 'AH'
          },
          {
            id: 204,
            title: 'Heel Holland bakt taart',
            image: 'https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=400&q=80',
            duration: '25 min',
            rating: '8.6',
            sponsor: 'Dr. Oetker'
          },
          {
            id: 205,
            title: 'Just do it',
            image: 'https://images.unsplash.com/photo-1504609813442-a8924e83f76e?w=400&q=80',
            duration: '30 min',
            rating: '7.9',
            sponsor: 'Nike'
          },
          {
            id: 206,
            title: 'De gemaskerde clown',
            image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&q=80',
            duration: '25 min',
            rating: '8.3',
            sponsor: 'Bol.com'
          },
          {
            id: 207,
            title: 'Liefde is alles',
            image: 'https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?w=400&q=80',
            duration: '30 min',
            rating: '7.7',
            sponsor: 'KLM'
          }
        ]
      },
      {
        title: 'Premium Lifestyle Shows',
        shows: [
          {
            id: 208,
            title: 'Amsterdam life',
            image: 'https://images.unsplash.com/photo-1542281286-9e0a16bb7366?w=400&q=80',
            duration: '25 min',
            rating: '8.0',
            sponsor: 'Mercedes-Benz'
          },
          {
            id: 209,
            title: 'Fashion wars NL',
            image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?w=400&q=80',
            duration: '30 min',
            rating: '7.8',
            sponsor: 'Vogue'
          },
          {
            id: 210,
            title: 'Travel goals',
            image: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&q=80',
            duration: '25 min',
            rating: '8.3',
            sponsor: 'KLM'
          },
          {
            id: 211,
            title: 'Tech innovators',
            image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&q=80',
            duration: '30 min',
            rating: '7.9',
            sponsor: 'Samsung'
          }
        ]
      },
      {
        title: 'Food & Cooking',
        shows: [
          {
            id: 212,
            title: 'Chef’s table',
            image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&q=80',
            duration: '25 min',
            rating: '8.7',
            sponsor: 'AH'
          },
          {
            id: 213,
            title: 'Bakery battle',
            image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&q=80',
            duration: '30 min',
            rating: '8.2',
            sponsor: 'Dr. Oetker'
          },
          {
            id: 214,
            title: 'Food truck challenge',
            image: 'https://images.unsplash.com/photo-1565123409695-7b5ef63a2efb?w=400&q=80',
            duration: '25 min',
            rating: '7.6',
            sponsor: 'Jumbo'
          }
        ]
      }
    ]
  },
  {
    id: 'old-reality',
    name: 'Vintage reality',
    shortcut: '3',
    description: 'Realityshows uit de oude doos',
    hero: {
      title: 'De Bauers',
      subtitle: 'Daar zijn ze weer',
      description: 'Herbeleef de iconische momenten met Frans en Mariska Bauer. De realitysoap die Nederland veroverde.',
      backgroundImage: '/content/old/debauers.jpeg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv De Bauers.mp4'),
      cta: 'Kijk nu!'
    },
    secondaryHero: {
      title: 'De Grannies',
      subtitle: 'De golden oldies',
      description: 'Een heerlijke kijk in het leven van deze bijzondere dames. Leeftijd is maar een nummer.',
      backgroundImage: '/content/old/de-grannies.jpeg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv De Grannies.mp4'),
      cta: 'Kijk nu!'
    },
    sections: [
      {
        title: 'De jaren 2000',
        shows: [
          {
            id: 301,
            title: 'De Grannies',
            image: '/content/old/de-grannies.jpeg',
            videoUrl: getSupabaseVideoUrl('Eddie Tv De Grannies.mp4'),
            duration: '30 min',
            rating: '8.5',
            year: '2005'
          },
          {
            id: 302,
            title: 'Volendam',
            image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=400&q=80',
            duration: '25 min',
            rating: '9.1',
            year: '2000'
          },
          {
            id: 303,
            title: 'Adam’s family',
            image: 'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=400&q=80',
            duration: '30 min',
            rating: '8.8',
            year: '2003'
          },
          {
            id: 304,
            title: 'Andrew & Melissa',
            image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400&q=80',
            duration: '25 min',
            rating: '7.9',
            year: '2001'
          },
          {
            id: 305,
            title: 'Robinson',
            image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80',
            duration: '30 min',
            rating: '8.5',
            year: '2000'
          },
          {
            id: 306,
            title: 'Idolen',
            image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&q=80',
            duration: '25 min',
            rating: '8.2',
            year: '2002'
          },
          {
            id: 307,
            title: 'Goud',
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80',
            duration: '30 min',
            rating: '7.4',
            year: '2001'
          }
        ]
      },
      {
        title: 'Beste vintage reality',
        shows: [
          {
            id: 308,
            title: 'Bekende buren',
            image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80',
            duration: '30 min',
            rating: '9.2',
            year: '2005'
          },
          {
            id: 309,
            title: 'Ranking the NL',
            image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=400&q=80',
            duration: '25 min',
            rating: '8.6',
            year: '2006'
          },
          {
            id: 310,
            title: 'Sterren glijden op het ijs',
            image: 'https://images.unsplash.com/photo-1551524164-687a55dd1126?w=400&q=80',
            duration: '30 min',
            rating: '8.4',
            year: '2004'
          },
          {
            id: 311,
            title: 'De kooi',
            image: 'https://images.unsplash.com/photo-1551244072-5d12893278ab?w=400&q=80',
            duration: '25 min',
            rating: '8.9',
            year: '2005'
          }
        ]
      },
      {
        title: 'Culthits',
        shows: [
          {
            id: 312,
            title: 'Vrouw bijt kat',
            image: 'https://images.unsplash.com/photo-1556155092-490a1ba16284?w=400&q=80',
            duration: '25 min',
            rating: '8.7',
            year: '1997'
          },
          {
            id: 313,
            title: 'Wat zoek jij?',
            image: 'https://images.unsplash.com/photo-1576267423445-b2e0074d68a4?w=400&q=80',
            duration: '30 min',
            rating: '7.8',
            year: '1999'
          },
          {
            id: 314,
            title: 'All you need is a man',
            image: 'https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?w=400&q=80',
            duration: '25 min',
            rating: '8.3',
            year: '2004'
          }
        ]
      }
    ]
  },
  {
    id: '24-7-reality',
    name: '24/7 Reality',
    shortcut: '4',
    description: 'Non-stop reality, de hele dag door',
    hero: {
      title: 'Bingo',
      subtitle: '24/7 live bingo',
      description: 'Bingo! De hele dag, vanuit de hele wereld. Speel mee en win!',
      backgroundImage: '/content/247/bingo.jpeg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Bingo.mp4'),
      cta: 'Kijk nu!'
    },
    secondaryHero: {
      title: 'Eagle Nest',
      subtitle: 'Puur natuur',
      description: 'Volg het leven in dit adelaarsnest 24 uur per dag. Een unieke blik in de natuur.',
      backgroundImage: '/content/247/eagle-nest.jpg',
      videoUrl: getSupabaseVideoUrl('Eddie Tv Eagle Nest.mp4'),
      cta: 'Kijk nu!'
    },
    sections: [
      {
        title: 'Livestreams',
        shows: [
          {
            id: 401,
            title: 'Eagle Nest',
            image: '/content/247/eagle-nest.jpg',
            videoUrl: getSupabaseVideoUrl('Eddie Tv Eagle Nest.mp4'),
            duration: 'LIVE',
            rating: '8.5',
            isLive: true
          },
          {
            id: 402,
            title: 'Live stream hotelkamer 201',
            image: 'https://images.unsplash.com/photo-1554755229-ca4470e07232?w=400&q=80',
            duration: 'LIVE',
            rating: '7.8',
            isLive: true
          },
          {
            id: 403,
            title: 'Live stream hotelkamer 404',
            image: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?w=400&q=80',
            duration: 'LIVE',
            rating: '7.6',
            isLive: true
          },
          {
            id: 404,
            title: 'Live stream studentenhuis',
            image: 'https://images.unsplash.com/photo-1464047736614-af63643285bf?w=400&q=80',
            duration: 'LIVE',
            rating: '8.0',
            isLive: true
          },
          {
            id: 405,
            title: 'Live stream koffiehuis',
            image: 'https://images.unsplash.com/photo-1502301103665-0b95cc738daf?w=400&q=80',
            duration: 'LIVE',
            rating: '7.5',
            isLive: true
          },
          {
            id: 406,
            title: 'Behind the scenes',
            image: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=400&q=80',
            duration: 'LIVE',
            rating: '8.2',
            isLive: true
          },
          {
            id: 407,
            title: 'Multi-Cam Artis',
            image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=400&q=80',
            duration: 'LIVE',
            rating: '8.4',
            isLive: true
          }
        ]
      },
      {
        title: 'Beste momenten vandaag',
        shows: [
          {
            id: 408,
            title: 'Ruzie in keuken',
            image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&q=80',
            duration: '3:24',
            rating: '8.7'
          },
          {
            id: 409,
            title: 'De kus',
            image: 'https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=400&q=80',
            duration: '5:12',
            rating: '8.3'
          },
          {
            id: 410,
            title: 'Een ei!',
            image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=400&q=80',
            duration: '2:45',
            rating: '8.9'
          },
          {
            id: 411,
            title: 'En de winnaar is',
            image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&q=80',
            duration: '4:33',
            rating: '8.1'
          }
        ]
      },
      {
        title: 'Meest bekeken deze week',
        shows: [
          {
            id: 412,
            title: 'Emotionele breakdown',
            image: 'https://images.unsplash.com/photo-1595769816263-9b910be24d5f?w=400&q=80',
            duration: '6:21',
            rating: '9.1'
          },
          {
            id: 413,
            title: 'Samen slapen',
            image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=400&q=80',
            duration: '8:15',
            rating: '8.8'
          },
          {
            id: 414,
            title: 'Drama, drama',
            image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&q=80',
            duration: '12:30',
            rating: '9.3'
          }
        ]
      }
    ]
  }
];

export const videoSources = [
  getSupabaseVideoUrl('Eddie Tv Monique.mp4'),
  getSupabaseVideoUrl('Eddie Tv Yves.mp4'),
  getSupabaseVideoUrl('Eddie Tv De Bauers.mp4'),
  getSupabaseVideoUrl('Eddie Tv De Grannies.mp4')
];
